<template>
	<div id="dropdown-container">
		<label class="dropdown-button clickable" @click="toggle">
			<font-awesome-icon :icon="objectIcon()" size="2x"/>
		</label>
		
	</div>
</template>


<script>


	export default {
		name: 'LandingDropdown',
		components: {
		},
		data: 
			function() {
				return {

					toggled: false,
				}
			},
		methods: {
			toggle() {
				if(!this.toggled) {
					this.$emit('showSidenav');
					this.toggled = true; 
					}
					else {
						this.$emit('hideSidenav');
						this.toggled = false;
						}
			},
			
			setIcon(toggled) {
				this.toggled = toggled;
			},
			
			objectIcon: function() {
				if(!this.toggled)
					return 'bars';
				if(this.toggled)
					return 'times';
			}
		}
	}
</script>

<style>

	.p-menitem {
		position: relative;
		padding-bottom: 0px;
		padding-right: 1px;
		border: 0;
	}

	.fa-bars {
		color: #959595;
	}
	
	.fa-times {
		color: #aa1c48;
	}
	

</style>

<style scoped>
	#dropdown-container {
		position: absolute;
		top: 25px;
		right: 0px;
		display: flex;
		flex-direction: column;
		transition: 0.5s;
		z-index: 11;
	}

	button {
		margin-right: 10px;
		height: 50px;
		width: 50px;
		position: relative;
		align-self: end;
	}

	.text-wrapper {
		position: absolute;
		bottom: 10pt;
		left: 50%;
		transform: translateX(-50%);
		-webkit-transform: translateX(-50%);
	}

		


	.dropdown-button {
		margin-right: 10px;
		height: 50px;
		width: 75px;
		position: relative;
		align-self: end;
		display: block;
		background: transparent;
		position: relative; 
	}

	font-awesome-icon {
		color: #red;
	}

	@media (min-width: 768px) {
		#dropdown-container {
			display: none;
		}
	}

</style>